import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';

interface Props {
  onClose: () => void;
  accountId?: string;
  onRetry: () => void;
}

export const AccountFormError = ({ onClose, accountId, onRetry }: Props) => {
  return (
    <Modal isOpen onRequestClose={onClose}>
      <ModalHeader id="account-modal-form">{accountId ? 'Edit' : 'Add'} Account</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box my="56">
          <ErrorState onAction={onRetry} />
        </Box>
      </ModalBody>
    </Modal>
  );
};
